export default __webpack_public_path__ + "static/media/rebalance-history.48e3ac07.svg";